/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Arkadium/GameEngine/Maths/Vector2',['pixi'], function (PIXI) {

    "use strict";

    var Vector2 = function (x, y) {
        this.initVector2(x, y);
    };

    Vector2.constructor = Vector2;
    Vector2.prototype = Object.create(PIXI.Point.prototype);

    Vector2.prototype.initVector2 = function (x, y) {
        x = x || 0;
        y = y || 0;
        PIXI.Point.call(this, x, y);
    };

    Object.defineProperty(Vector2.prototype, "X", {
        get: function () {
            return this.x;
        },
        set: function (value) {
            this.x = value;
        }
    });

    Object.defineProperty(Vector2.prototype, "Y", {
        get: function () {
            return this.y;
        },
        set: function (value) {
            this.y = value;
        }
    });

    Object.defineProperty(Vector2.prototype, "LengthSquared", {
        get: function () {
            return this.x * this.x + this.y * this.y
        }
    });

    Object.defineProperty(Vector2.prototype, "Length", {
        get: function () {
            return Math.sqrt(this.x * this.x + this.y * this.y);
        }
    });

    Vector2.prototype.clone = function () {
        return new Vector2(this.x, this.y);
    };

    Vector2.Zero = new Vector2(0, 0);

    return Vector2;

});
